import styled from 'styled-components';
import { flexGap } from 'untils/polyfill/flex';

const Container = styled.div`
  width: 1100px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
  padding: var(--home-block-padding) 0;
  ${flexGap('16px')}
`;

const JetImg = styled.img`
  object-fit: cover;
`;

const DescBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  ${flexGap('16px')}
  background: #f4f6fc;
  padding: 24px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  ${flexGap('16px')}
`;

const Title = styled.h3`
  font-weight: 600;
  font-size: 40px;
  margin: 0;
  line-height: normal;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  ${flexGap('16px')}
`;

const Desc = styled.p`
  font-weight: 400;
  font-size: 16px;
  color: #424748;
  display: flex;
  flex-direction: column;
  ${flexGap('12px')}
  line-height: 1.3;
`;

const Link = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 41px;
  background: #fff;
  color: #424748;
  cursor: pointer;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  &:hover {
    color: #050a30;
  }
`;

const ToCharter = styled(Link)`
  background: #1f68db;
  color: #fff;
  &:hover {
    color: #fff;
  }
`;

const DescImg = styled.img`
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 2px;
`;

const PrecisionDetail = () => {
  return (
    <Container>
      <DescBox>
        <Header>
          <Title>Precision in Every Detail</Title>
          <Footer>
            <Desc>
              <p>
                Your travel should be as refined as your lifestyle. Tell us where you want to fly
                and what truly matters to you onboard.
                <br />
                Our team will curate a proposal with real-world examples of how we can elevate your
                experience.
              </p>
              <p>Let’s bring your vision of perfect air travel to life.</p>
            </Desc>
            <ToCharter href="/charterQuote">Plan Your Next Trip</ToCharter>
          </Footer>
        </Header>
        <DescImg
          src="/imgs/webp/home/people-back.webp"
          alt="Regional jet available at a discount price
"
        />
      </DescBox>

      <JetImg
        src="/imgs/webp/home/personalized-private-jet.webp"
        alt="Safe, flexible, and personalized private flying"
      ></JetImg>
    </Container>
  );
};

export default PrecisionDetail;
